import gql from 'graphql-tag';

export const DidContainUserContentFragment = gql`
	fragment DidContainUserContentFragment on Space {
		didContainUserContent
	}
`;
